(function(){
  "use strict";

  if (window.__PO_K5_TAKIMARAH_TEXTS_20260303__) return;
  window.__PO_K5_TAKIMARAH_TEXTS_20260303__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AXIS_LEX_ID = "takimarah";
  var ROOT_SEL =
    '.po-axis-section[data-po-axis][data-po-lex-id="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-axis="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-lex-id="' + AXIS_LEX_ID + '"]';

  var URLS = {
    lexicon: "https://goodyart.store/pages/lexique-simplifie/",
    katuvys: "https://goodyart.store/pages/katuvys",
    ekho: "https://goodyart.store/pages/ekho",
    katusys: "https://goodyart.store/pages/katusys",
    lulaesirasen: "https://goodyart.store/pages/lulaesirasen",
    tiqqunbahu: "https://goodyart.store/pages/tiqqunbahu",
    katuvysissence: "https://goodyart.store/pages/katuvysissence",
    katuvysqun: "https://goodyart.store/pages/katuvysqun",
    balakallpa: "https://goodyart.store/pages/balakallpa",
    takimarah: "https://goodyart.store/pages/takimarah",
    title: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Takimarah_copie_2.png?v=1772886695",
    chip_element: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535",
    chip_totem: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195",
    chip_freq: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_82.png?v=1773411110"
  };

  function clampStr(v){ return (v == null) ? "" : String(v); }
  function qs(root, sel){ try{ return root.querySelector(sel); }catch(e){ return null; } }
  function qsa(root, sel){ try{ return Array.prototype.slice.call(root.querySelectorAll(sel)); }catch(e){ return []; } }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim();
    if (s === "fr" || s === "en" || s === "es") return s;
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return normLang(v || "fr");
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{ if (document && document.documentElement) document.documentElement.setAttribute("lang", l); }catch(__e){}
    return l;
  }

  function getLang(){ return readStoredLang(); }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickAny(entry, key, fallback){
    try{
      if (entry && entry[key] != null) return entry[key];
    }catch(e){}
    return fallback;
  }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/\"/g,"&quot;")
      .replace(/'/g,"&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);
    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    return [];
  }

  function buildProtectRegexFromSimplified(){
    var base = getSimplifiedLexiqueFRList();
    if (!base || !base.length) return null;

    var terms = [];
    var seen = Object.create(null);
    for (var i=0;i<base.length;i++){
      var vars = buildVariants(base[i]);
      for (var j=0;j<vars.length;j++) uniqPush(terms, vars[j], seen);
    }
    terms.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<terms.length;k++) parts.push(escapeRegExp(terms[k]));
    if (!parts.length) return null;

    try{ return new RegExp("(" + parts.join("|") + ")", "g"); }
    catch(e){ return null; }
  }

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function ensureProtectEngineReady(){
    var key = "meta:none";
    try{
      var l = getSimplifiedLexiqueFRList();
      key = "meta:" + (l ? l.length : 0);
    }catch(e){ key = "meta:none"; }
    if (__PO_PROTECT_CACHE__.key === key) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegexFromSimplified();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch);
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;

    re.lastIndex = 0;
    if (!re.test(txt)) return;
    re.lastIndex = 0;

    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;

      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(" "));

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(" "));

      last = end;
      if (match.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;
    var walker;

    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return String(html); }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;

    var walker;
    try{
      walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            var p = n.parentNode;
            var pn = p && p.nodeName ? p.nodeName : "";
            if (pn === "SCRIPT" || pn === "STYLE") return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return; }

    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt);
    if (!s) return "";
    return "<p>" + escapeHTML(s).replace(/\n+/g, "</p><p>") + "</p>";
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: "",
    lang: "fr",
    voice: null
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){ var L = normLang(lang); return AUDIO_UI[L] || AUDIO_UI.fr; }
  function getAudioRoots(){ return qsa(document, ROOT_SEL); }
  function getDetailBlocks(root){ return root ? qsa(root, ".po-lex-details") : []; }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.textContent || el.innerText || ""; }catch(e){ txt = ""; }
    return clampStr(txt).replace(/\s+/g, " ").replace(/\s([:;!?])/g, "$1").trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    qsa(root, ".po-axis-audio-wrap, .po-audio-btn").forEach(function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-k5-takimarah-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-k5-takimarah-audio-styles";
    style.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;margin:12px 0 14px;}',
      '.po-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(0,0,0,.02);color:inherit;border-radius:999px;padding:8px 14px;font:inherit;font-size:12px;line-height:1;cursor:pointer;transition:transform .18s ease,box-shadow .18s ease,border-color .18s ease,background .18s ease;}',
      '.po-audio-btn:hover{transform:translateY(-1px);box-shadow:0 8px 18px rgba(31,122,58,.10);border-color:rgba(184,134,11,.55);}',
      '.po-audio-btn.is-active{border-color:rgba(184,134,11,.75);background:rgba(31,122,58,.04);box-shadow:0 0 0 1px rgba(184,134,11,.18),0 8px 18px rgba(31,122,58,.10);font-weight:700;}',
      '.po-lex-summary .po-audio-btn{margin-left:auto;flex:0 0 auto;}',
      '.po-lex-summary__title{display:inline-flex;align-items:center;gap:10px;}',
      '@media (max-width:760px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-audio-btn{order:3;margin-left:0;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-role", role);
    btn.setAttribute("aria-pressed", "false");
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();

    var panel = qs(root, '.po-lex-panel');
    var generalWrap = qs(root, '.po-axis-audio-wrap[data-po-audio-role="general"]');
    if (!generalWrap){
      generalWrap = document.createElement("div");
      generalWrap.className = "po-axis-audio-wrap notranslate";
      generalWrap.setAttribute("translate", "no");
      generalWrap.setAttribute("data-po-audio-role", "general");
      generalWrap.appendChild(createAudioButton("general"));
    }

    if (panel){
      var meta = qs(panel, '.po-axis-meta');
      var defShort = qs(panel, '[data-po-slot="def_short"]');
      var firstDetails = qs(panel, '.po-lex-details');

      if (meta && meta.parentNode === panel){
        if (meta.nextSibling !== generalWrap) panel.insertBefore(generalWrap, meta.nextSibling);
      } else if (defShort && defShort.parentNode === panel){
        if (defShort.previousSibling !== generalWrap) panel.insertBefore(generalWrap, defShort);
      } else if (firstDetails && firstDetails.parentNode === panel){
        if (firstDetails.previousSibling !== generalWrap) panel.insertBefore(generalWrap, firstDetails);
      } else if (panel.firstChild !== generalWrap){
        panel.insertBefore(generalWrap, panel.firstChild);
      }
    }

    getDetailBlocks(root).forEach(function(details, idx){
      var summary = qs(details, ".po-lex-summary");
      if (!summary) return;
      var btn = qs(summary, '.po-audio-btn[data-po-audio-role="block"]');
      if (!btn){
        btn = createAudioButton("block");
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(idx));
    });

    bindAudioButtons(root, lang);
  }

  function refreshAudioButtons(root, lang){
    if (!root) return;
    var ui = audioUI(lang);
    qsa(root, ".po-audio-btn").forEach(function(btn){
      var role = btn.getAttribute("data-po-audio-role");
      var key = role === "general" ? "general" : ("block:" + (btn.getAttribute("data-po-audio-index") || "0"));
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key);
      btn.textContent = active ? ui.stop : (role === "general" ? ui.general : ui.block);
      btn.classList.toggle("is-active", !!active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function bindAudioButtons(root, lang){
    qsa(root, ".po-audio-btn").forEach(function(btn){
      if (btn.__poAudioBound) return;
      btn.__poAudioBound = true;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = btn.getAttribute("data-po-audio-role");
        var key = role === "general" ? "general" : ("block:" + (btn.getAttribute("data-po-audio-index") || "0"));
        if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key){
          stopAudio();
          refreshAudioButtons(root, readStoredLang());
          return;
        }
        startAudio(root, readStoredLang(), key);
      }, false);
    });
    refreshAudioButtons(root, lang);
  }

  function textFromNode(node){
    if (!node) return '';
    var clone = node.cloneNode(true);
    qsa(clone, 'script,style,.po-audio-btn,.po-axis-audio-wrap,.po-lex-summary__hint').forEach(function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    var txt = (clone.innerText || clone.textContent || '')
      .replace(/\s+/g, ' ')
      .replace(/\s([:;!?])/g, '$1')
      .trim();
    return txt;
  }

  function buildIntroText(root){
    var parts = [];
    ['title','kicker','h_def','def_short','def_long'].forEach(function(slot){
      var node = qs(root, '[data-po-slot="' + slot + '"]');
      var txt = textFromNode(node);
      if (txt) parts.push(txt);
    });
    return parts.join('. ');
  }

  function buildBlockText(details){
    if (!details) return '';
    var parts = [];
    var summary = qs(details, '.po-lex-summary');
    if (summary){
      var title = textFromNode(qs(summary, '.po-lex-summary__title'));
      if (title) parts.push(title);
    }
    var clone = details.cloneNode(true);
    clone.open = true;
    qsa(clone, '.po-audio-btn,.po-axis-audio-wrap,.po-lex-summary__hint').forEach(function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    var summaryClone = qs(clone, '.po-lex-summary');
    if (summaryClone && summaryClone.parentNode) summaryClone.parentNode.removeChild(summaryClone);
    var txt = textFromNode(clone);
    if (txt) parts.push(txt);
    return parts.join('. ');
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, ' ').trim();
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:]+[.!?;:]?/g) || [raw];
    var out = [];
    var current = '';

    for (var i=0;i<pieces.length;i++){
      var piece = clampStr(pieces[i]).trim();
      if (!piece) continue;
      var next = current ? (current + ' ' + piece) : piece;
      if (next.length > 220){
        if (current) out.push(current.trim());
        if (piece.length > 220){
          var words = piece.split(/\s+/);
          var acc = '';
          for (var j=0;j<words.length;j++){
            var w = words[j];
            if (!w) continue;
            var merged = acc ? (acc + ' ' + w) : w;
            if (merged.length > 220){
              if (acc) out.push(acc.trim());
              acc = w;
            }else acc = merged;
          }
          current = acc || '';
        }else current = piece;
      }else current = next;
    }
    if (current) out.push(current.trim());
    return out;
  }

  function getVoices(){
    try{ return PO_AUDIO_SYNTH ? (PO_AUDIO_SYNTH.getVoices() || []) : []; }
    catch(e){ return []; }
  }

  function pickVoiceForLang(lang){
    var voices = getVoices();
    if (!voices.length) return null;
    var target = normLang(lang);
    var targets = target === 'fr' ? ['fr','fr-fr','fr_ca','fr-ca'] : target === 'en' ? ['en','en-us','en-gb'] : ['es','es-es','es-mx','es-us'];
    var i, v, vl;
    for (i=0;i<voices.length;i++){
      v = voices[i];
      vl = clampStr(v.lang).toLowerCase();
      if (targets.indexOf(vl) !== -1) return v;
    }
    for (i=0;i<voices.length;i++){
      v = voices[i];
      vl = clampStr(v.lang).toLowerCase();
      if (vl.indexOf(target) === 0) return v;
    }
    return voices[0] || null;
  }

  function getSpeechLangCode(lang){
    var L = normLang(lang);
    if (L === 'en') return 'en-US';
    if (L === 'es') return 'es-ES';
    return 'fr-FR';
  }

  function stopAudio(){
    try{
      if (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) PO_AUDIO_SYNTH.cancel();
    }catch(e){}
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.voice = null;
    getAudioRoots().forEach(function(root){ refreshAudioButtons(root, readStoredLang()); });
  }

  function openDetailIfNeeded(detail){
    if (!detail) return;
    try{ detail.open = true; }catch(e){}
  }

  function advanceAudioUnit(){
    if (!PO_AUDIO_STATE.root) return stopAudio();
    PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) return stopAudio();

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit) return stopAudio();
    if (unit.type === 'detail' && unit.detail) openDetailIfNeeded(unit.detail);

    PO_AUDIO_STATE.activeKey = unit.key;
    PO_AUDIO_STATE.chunks = splitTextForSpeech(unit.text || '');
    PO_AUDIO_STATE.chunkPos = -1;
    refreshAudioButtons(PO_AUDIO_STATE.root, PO_AUDIO_STATE.lang);
    speakNextChunk();
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH) return stopAudio();
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length) return advanceAudioUnit();

    var chunk = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!chunk) return speakNextChunk();

    var utter = new SpeechSynthesisUtterance(chunk);
    utter.lang = getSpeechLangCode(PO_AUDIO_STATE.lang);
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.rate = 0.98;
    utter.pitch = 1;
    utter.onend = function(){ speakNextChunk(); };
    utter.onerror = function(){ speakNextChunk(); };

    try{ PO_AUDIO_SYNTH.speak(utter); }
    catch(e){ stopAudio(); }
  }

  function buildUnits(root, startKey){
    var units = [];
    var intro = buildIntroText(root);
    var details = getDetailBlocks(root);
    var startIdx = 0;

    if (startKey === 'general'){
      if (intro) units.push({ type:'general', key:'general', text:intro });
    } else if (String(startKey || '').indexOf('block:') === 0){
      startIdx = parseInt(String(startKey).split(':')[1], 10);
      if (isNaN(startIdx) || startIdx < 0) startIdx = 0;
    }

    for (var i=startIdx;i<details.length;i++){
      var txt = buildBlockText(details[i]);
      if (txt) units.push({ type:'detail', key:'block:' + i, detail:details[i], text:txt });
    }

    if (startKey !== 'general' && !units.length && intro){
      units.push({ type:'general', key:'general', text:intro });
    }
    return units;
  }

  function startAudio(root, lang, key){
    if (!root || !PO_AUDIO_SYNTH) return;
    try{ if (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending) PO_AUDIO_SYNTH.cancel(); }catch(e){}

    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.lang = normLang(lang);
    PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang);
    PO_AUDIO_STATE.units = buildUnits(root, key);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = key;

    if (!PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }
    advanceAudioUnit();
  }

  function initAudioEverywhere(lang){
    getAudioRoots().forEach(function(root){
      ensureAudioButtons(root, lang);
      refreshAudioButtons(root, lang);
    });
  }

  /* --------------------------------------------------------------------------
   * FALLBACK CONTENT
   * -------------------------------------------------------------------------- */

  var FALLBACK = {
    fr: {
      title: "Takimarah",
      kicker: "Extrait du <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs : interface modulante / matrice de canalisation)",
      h_def: "Définition opérative",
      chips: ["Élément", "Totem", "Fréquence"],
      def_short: "Interface modulante d’ajustement vibratoire : mécanisme de canalisation rythmique dans les interstices du champ katûvýsique, stabilisant les déphasages, harmonisant les rythmes, et redistribuant les flux selon leur tension.",
      def_long: "Au sein de la Katûvýs, Takimarah désigne une entité épicène invariable assurant une fonction d’ajustement vibratoire dynamique dans les zones de transition, de tension et de reconfiguration du champ katûvýsique. Le texte la définit comme interface modulaire : dispositif d’équilibrage rythmique permettant à Katûsýs — ensemble unifié des huit unités internes — de conserver une cohérence énergétique fluide au moment même où les syntonies varient et se redistribuent.\n\nTakimarah agit comme un adaptateur vivant : elle accompagne en continu les fluctuations de densité, d’intensité, d’orientation et de fréquence. Son rôle se déploie en trois gestes opératifs complémentaires : stabiliser les déphasages temporaires en maintenant le mouvement vivant ; harmoniser les rythmes internes issus de la modulation de Katûsýs ; canaliser ou redistribuer les flux selon leur degré de tension.\n\nLa modulation assurée par Takimarah se déploie selon deux modes canoniques : en cascade, lorsque le champ requiert une succession de rééquilibrages progressifs ; en miroir, lorsque la dynamique appelle un renvoi de la tension vers son point d’origine afin d’en transformer la charge. Cette logique soutient la continuité rythmique du système dans les activations complexes de Katûvýsqun, les séquences collectives impliquant Balakallpa et les phases de préparation avant changement de configuration systémique.",
      h_features: "Schématisation",
      h_questions: "Repères d’activation",
      hint_fold: "déplier",
      hint_fold2: "déplier",
      hint_fold3: "déplier",
      example_title: "Ex.",
      example: "Quand un flux décale, se surcharge ou change brusquement de direction, Takimarah devient le réglage fin qui tient le passage sans casser la mobilité. En cascade, tu étages les rééquilibrages ; en miroir, tu renvoies la charge à sa source pour la transformer.",
      features: [
        "Statut : interface modulante ; matrice de canalisation ; ajustement vibratoire dynamique.",
        "Fonction : convertir variations de densité, d’intensité, de direction et de fréquence en tenue dynamique par micro-modulations.",
        "Modes opératifs : cascade (rééquilibrages étagés) ; miroir (renvoi-source et transformation).",
        "Relations prioritaires : Lulæṣírasen, Tiqqunbahu, Katûvýsissence.",
        "Usages situés : Katûvýsqun, Balakallpa, préparation d’un changement de configuration systémique."
      ],
      questions: [
        "Y a-t-il un excès local, un déphasage perceptible, une variation de direction ou une surcharge rythmique ?",
        "Faut-il étager la régulation en cascade, ou renvoyer la charge à son point-source en miroir ?",
        "Quelle co-activation de Katûsýs exige une tenue continue plutôt qu’une décision brutale ?",
        "La trace de Katûvýsissence revient-elle comme ressource à moduler plutôt que comme poids à subir ?"
      ],
      h_family: "Relations systémiques (voisinages)",
      family_1: "<p><strong>Noyau relationnel :</strong> Takimarah se tient au contact direct de <span class=\"notranslate\" translate=\"no\">Lulæṣírasen</span>, <span class=\"notranslate\" translate=\"no\">Tiqqunbahu</span> et <span class=\"notranslate\" translate=\"no\">Katûvýsissence</span>. Elle rend praticable l’oscillation : variation rythmique, respiration d’intégration, modulation de trace, redistribution tenue.</p>",
      family_2: "<p><strong>Syntonie symbolique :</strong> <em>Taki</em> (cascade) et <em>Mar’ah</em> (miroir) configurent un mécanisme fluidique réflexif : descente tenue, réflexion transductive, interface comme intelligence de modulation. La fréquence 82 soutient une zone d’équilibrage permanent, un retour au point-source et une souplesse d’écoute en mouvement.</p>",
      h_wordbuild: "Construction du concept (Taki + Mar’ah) & fréquence 82",
      word_blocks: [
        { head: "Taki (滝) — cascade", text: "Flux continu et rythmé ; chute structurée par gravité ; intensité concentrée puis transformée sans dispersion. Lecture opérative : canalisation en cascade, étagement des rééquilibrages, purification et tenue de passage." },
        { head: "Mar’ah (מַרְאָה) — miroir", text: "Vision indirecte ; renvoi, retournement, résonance. Lecture opérative : réflexion modulante, renvoi de charge vers la source, transformation par syntonie." },
        { head: "Fréquence 82 — lecture opérative", text: "8 + 2 = 10 : transition articulée, bascule tenue.\n1 + 0 = 1 : retour au point-source.\n80 + 2 = 82 : cadre structurant accordé à une polarité d’écoute, de souplesse et d’ajustement vivant." }
      ],
      word_notes: [
        "Élément : La Katûvýs ; Totem : Êkhö ; Fréquence : 82.",
        "Takimarah agit par micro-modulations successives : elle oriente le flux sans figer sa trajectoire.",
        "Phrase opérative : « Takimarah : je canalise la tension en mouvement, je renvoie la charge à sa source, et le flux retrouve sa tenue par modulation. »"
      ],
      cta_translate: "Proposer une traduction du concept"
    },
    en: {
      title: "Takimarah",
      kicker: "Excerpt from <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs: modulatory interface / canalization matrix)",
      h_def: "Operative definition",
      chips: ["Element", "Totem", "Frequency"],
      def_short: "Modulatory interface for vibratory adjustment: a rhythmic canalization mechanism within the interstices of the katûvýsian field, stabilizing phase shifts, harmonizing inner rhythms, and redistributing flows according to their tension.",
      def_long: "Within Katûvýs, Takimarah names an epicene invariable entity ensuring dynamic vibratory adjustment in zones of transition, tension and reconfiguration. The corpus describes it as a modular interface: a rhythmic balancing device enabling Katûsýs — the unified set of eight internal units — to maintain fluid energetic coherence while syntonies vary and redistribute.\n\nTakimarah acts as a living adapter: it continuously accompanies fluctuations of density, intensity, direction and frequency. Its role unfolds through three complementary gestures: stabilizing temporary phase shifts while keeping movement alive; harmonizing the inner rhythms produced by Katûsýs modulation; canalizing and redistributing flows according to their tension and trajectory.\n\nIts regulation is written in two canonical modes: cascade, when the field calls for staged progressive rebalancing; mirror, when the dynamic asks for a load to be returned to its source for transformation. This supports rhythmic continuity in complex Katûvýsqun activations, collective sequences involving Balakallpa, and preparatory phases before systemic reconfiguration.",
      h_features: "Schematic view",
      h_questions: "Activation markers",
      hint_fold: "expand",
      hint_fold2: "expand",
      hint_fold3: "expand",
      example_title: "Ex.",
      example: "When a flow shifts, overloads, or changes direction abruptly, Takimarah becomes the fine-tuning that holds the passage without breaking mobility. In cascade, you stage the rebalancing; in mirror, you return the load to its source for transformation.",
      features: [
        "Status: modulatory interface; canalization matrix; dynamic vibratory adjustment.",
        "Function: turn variations of density, intensity, direction and frequency into dynamic hold through micro-modulations.",
        "Operative modes: cascade (staged rebalancing); mirror (source-return and transformation).",
        "Priority relations: Lulæṣírasen, Tiqqunbahu, Katûvýsissence.",
        "Situated uses: Katûvýsqun, Balakallpa, preparation before systemic reconfiguration."
      ],
      questions: [
        "Is there a local excess, a perceptible phase shift, a direction variation, or rhythmic overload?",
        "Should regulation be staged in cascade, or returned to the source in mirror?",
        "Which co-activation of Katûsýs requires continuous holding rather than a blunt decision?",
        "Is the trace in Katûvýsissence returning as a resource to modulate rather than a weight to endure?"
      ],
      h_family: "Systemic relations",
      family_1: "<p><strong>Relational core:</strong> Takimarah stands in direct contact with <span class=\"notranslate\" translate=\"no\">Lulæṣírasen</span>, <span class=\"notranslate\" translate=\"no\">Tiqqunbahu</span> and <span class=\"notranslate\" translate=\"no\">Katûvýsissence</span>. It makes oscillation workable through rhythmic variation, integration-breath, trace modulation and redistributed continuity.</p>",
      family_2: "<p><strong>Symbolic syntony:</strong> <em>Taki</em> (cascade) and <em>Mar’ah</em> (mirror) configure a fluidic reflexive mechanism: held descent, transductive reflection, interface as modulation intelligence. Frequency 82 sustains a zone of permanent balancing, return to the source-point, and listening-flexibility in motion.</p>",
      h_wordbuild: "Concept building (Taki + Mar’ah) & frequency 82",
      word_blocks: [
        { head: "Taki (滝) — cascade", text: "Continuous rhythmic flow; gravity-structured fall; intensity concentrated then transformed without dispersion. Operatively: cascade canalization, staged rebalancing, purification and passage-hold." },
        { head: "Mar’ah (מַרְאָה) — mirror", text: "Indirect vision; return, reversal, resonance. Operatively: modulatory reflection, source-return of load, transformation by syntony." },
        { head: "Frequency 82 — operative reading", text: "8 + 2 = 10: articulated transition, held shift.\n1 + 0 = 1: return to the source-point.\n80 + 2 = 82: structuring frame tuned to listening, flexibility and living adjustment." }
      ],
      word_notes: [
        "Element: Katûvýs; Totem: Êkhö; Frequency: 82.",
        "Takimarah acts through successive micro-modulations: it orients the flow without freezing its trajectory.",
        "Operative phrase: “Takimarah: I canalize the moving tension, I return the load to its source, and the flow regains its hold through modulation.”"
      ],
      cta_translate: "Suggest a translation of the concept"
    },
    es: {
      title: "Takimarah",
      kicker: "Extracto de <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs: interfaz modulante / matriz de canalización)",
      h_def: "Definición operativa",
      chips: ["Elemento", "Tótem", "Frecuencia"],
      def_short: "Interfaz modulante de ajuste vibratorio: mecanismo de canalización rítmica en los intersticios del campo katûvýsico, estabiliza desfases, armoniza ritmos internos y redistribuye los flujos según su tensión.",
      def_long: "En la Katûvýs, Takimarah nombra una entidad epicena e invariable que asegura un ajuste vibratorio dinámico en zonas de transición, tensión y reconfiguración. El corpus la describe como interfaz modular: dispositivo de equilibrado rítmico que permite a Katûsýs — conjunto unificado de ocho unidades internas — mantener una coherencia energética fluida mientras las sintonías varían y se redistribuyen.\n\nTakimarah actúa como adaptador vivo: acompaña continuamente fluctuaciones de densidad, intensidad, dirección y frecuencia. Su función se despliega en tres gestos complementarios: estabilizar desfases temporales manteniendo vivo el movimiento; armonizar los ritmos internos producidos por la modulación de Katûsýs; canalizar y redistribuir los flujos según su tensión y su trayectoria.\n\nSu regulación se escribe en dos modos canónicos: cascada, cuando el campo requiere reequilibrios progresivos escalonados; espejo, cuando la dinámica pide devolver la carga a su fuente para transformarla. Esta lógica sostiene la continuidad rítmica en activaciones complejas de Katûvýsqun, secuencias colectivas con Balakallpa y fases de preparación antes de una reconfiguración sistémica.",
      h_features: "Esquematización",
      h_questions: "Referentes de activación",
      hint_fold: "desplegar",
      hint_fold2: "desplegar",
      hint_fold3: "desplegar",
      example_title: "Ej.",
      example: "Cuando un flujo se descuadra, se sobrecarga o cambia bruscamente de dirección, Takimarah se vuelve el ajuste fino que sostiene el pasaje sin romper la movilidad. En cascada, escalonas los reequilibrios; en espejo, devuelves la carga a su fuente para transformarla.",
      features: [
        "Estatus: interfaz modulante; matriz de canalización; ajuste vibratorio dinámico.",
        "Función: convertir variaciones de densidad, intensidad, dirección y frecuencia en sostén dinámico por micro-modulaciones.",
        "Modos operativos: cascada (reequilibrio escalonado); espejo (retorno a la fuente y transformación).",
        "Relaciones prioritarias: Lulæṣírasen, Tiqqunbahu, Katûvýsissence.",
        "Usos situados: Katûvýsqun, Balakallpa, preparación antes de reconfiguración sistémica."
      ],
      questions: [
        "¿Hay exceso local, desfase perceptible, variación de dirección o sobrecarga rítmica?",
        "¿Conviene escalonar la regulación en cascada, o devolverla a la fuente en espejo?",
        "¿Qué co-activación de Katûsýs exige sostén continuo en lugar de una decisión brusca?",
        "¿La traza de Katûvýsissence vuelve como recurso a modular y no como peso que soportar?"
      ],
      h_family: "Relaciones sistémicas",
      family_1: "<p><strong>Núcleo relacional:</strong> Takimarah se sitúa en contacto directo con <span class=\"notranslate\" translate=\"no\">Lulæṣírasen</span>, <span class=\"notranslate\" translate=\"no\">Tiqqunbahu</span> y <span class=\"notranslate\" translate=\"no\">Katûvýsissence</span>. Vuelve practicable la oscilación mediante variación rítmica, respiración de integración, modulación de traza y continuidad redistribuida.</p>",
      family_2: "<p><strong>Sintonía simbólica:</strong> <em>Taki</em> (cascada) y <em>Mar’ah</em> (espejo) configuran un mecanismo fluídico reflexivo: descenso sostenido, reflexión transductiva, interfaz como inteligencia de modulación. La frecuencia 82 sostiene una zona de equilibrio permanente, retorno al punto-fuente y flexibilidad de escucha en movimiento.</p>",
      h_wordbuild: "Construcción (Taki + Mar’ah) y frecuencia 82",
      word_blocks: [
        { head: "Taki (滝) — cascada", text: "Flujo continuo y rítmico; caída estructurada por gravedad; intensidad concentrada y transformada sin dispersión. Operativamente: canalización en cascada, reequilibrio escalonado, purificación y sostén del pasaje." },
        { head: "Mar’ah (מַרְאָה) — espejo", text: "Visión indirecta; retorno, inversión, resonancia. Operativamente: reflexión modulante, retorno de la carga a la fuente, transformación por sintonía." },
        { head: "Frecuencia 82 — lectura operativa", text: "8 + 2 = 10: transición articulada, basculación sostenida.\n1 + 0 = 1: retorno al punto-fuente.\n80 + 2 = 82: marco estructurante afinado por la escucha, la flexibilidad y el ajuste vivo." }
      ],
      word_notes: [
        "Elemento: Katûvýs; Tótem: Êkhö; Frecuencia: 82.",
        "Takimarah actúa por micro-modulaciones sucesivas: orienta el flujo sin fijar su trayectoria.",
        "Frase operativa: « Takimarah: canalizo la tensión en movimiento, devuelvo la carga a su fuente, y el flujo recupera su sostén por modulación. »"
      ],
      cta_translate: "Proponer una traducción del concepto"
    }
  };

  function setSlotText(root, slot, txt){
    var el = qs(root, "[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, "[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(clampStr(html));
  }

  function setSlotImg(root, slot, src, alt){
    var el = qs(root, "[data-po-slot='" + slot + "']");
    if (!el) return;
    var s = clampStr(src);
    var a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt",""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }
    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function renderListInto(root, slot, items){
    var el = qs(root, "[data-po-slot='" + slot + "']");
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      out.push("<li>" + protectKeywordsHTML(escapeHTML(clampStr(arr[i]))) + "</li>");
    }
    el.innerHTML = out.join("");
  }

  function renderWordBlocks(root, slot, blocks){
    var host = qs(root, "[data-po-slot='" + slot + "']");
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(escapeHTML(clampStr(b.head || ""))) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(escapeHTML(clampStr(b.text || "")).replace(/\n/g, "<br />")) + '</div>' +
        '</div>'
      );
    }
    host.innerHTML = out.join("");
  }

  function setCtaTranslate(root, lang){
    var el = qs(root, '[data-po-slot="cta_translate"]');
    if (!el) return;
    el.textContent = clampStr((FALLBACK[lang] && FALLBACK[lang].cta_translate) || FALLBACK.fr.cta_translate);
  }

  function resolveMainEntry(root){
    var id = "";
    try{ id = root.getAttribute("data-po-lex-id") || ""; }catch(e){ id = ""; }
    return getLexiconEntry(id) || getLexiconEntry("takimarah") || getLexiconEntry("Takimarah") || null;
  }

  function chooseFallback(lang){
    var l = normLang(lang);
    return FALLBACK[l] || FALLBACK.fr;
  }

  function renderAxis(root, lang){
    var L = chooseFallback(lang);
    var eMain = resolveMainEntry(root);

    var titleFR = (eMain ? pickTerm(eMain, 'fr') : '') || FALLBACK.fr.title;
    setSlotText(root, 'title', titleFR);
    setSlotImg(root, 'title_img', URLS.title, titleFR);

    var kicker = '';
    if (eMain){
      kicker = clampStr(pickAny(eMain, 'kicker_' + lang, '')) || clampStr(pickAny(eMain, 'kicker_fr', '')) || clampStr(pickAny(eMain, 'kicker', ''));
    }
    setSlotHTML(root, 'kicker', kicker || L.kicker);

    setSlotText(root, 'h_def', L.h_def);
    setSlotText(root, 'chip_1', (L.chips && L.chips[0]) || '');
    setSlotText(root, 'chip_2', (L.chips && L.chips[1]) || '');
    setSlotText(root, 'chip_3', (L.chips && L.chips[2]) || '');

    setSlotImg(root, 'chip_1_img', URLS.chip_element, (L.chips && L.chips[0]) || 'Élément');
    setSlotImg(root, 'chip_2_img', URLS.chip_totem, (L.chips && L.chips[1]) || 'Totem');
    setSlotImg(root, 'chip_3_img', URLS.chip_freq, (L.chips && L.chips[2]) || 'Fréquence');

    setSlotHTML(root, 'def_short', '<div>' + protectKeywordsHTML(escapeHTML(L.def_short)) + '</div>');
    setSlotHTML(root, 'def_long', htmlParagraphize(L.def_long));

    setSlotText(root, 'h_features', L.h_features);
    setSlotText(root, 'hint_fold', L.hint_fold);
    renderListInto(root, 'features', L.features || []);

    setSlotText(root, 'h_questions', L.h_questions);
    setSlotText(root, 'hint_fold2', L.hint_fold2);
    renderListInto(root, 'questions', L.questions || []);
    setSlotHTML(root, 'example_box', '<div><strong>' + protectKeywordsHTML(escapeHTML(L.example_title || 'Ex.')) + '</strong> ' + protectKeywordsHTML(escapeHTML(L.example || '')) + '</div>');

    setSlotText(root, 'h_family', L.h_family);
    setSlotText(root, 'hint_fold3', L.hint_fold3);
    setSlotHTML(root, 'family_1', L.family_1 || '');
    setSlotHTML(root, 'family_2', L.family_2 || '');

    setSlotText(root, 'h_wordbuild', L.h_wordbuild);
    renderWordBlocks(root, 'wordbuild_blocks', L.word_blocks || []);
    renderListInto(root, 'wordbuild_notes', L.word_notes || []);

    setCtaTranslate(root, lang);
    ensureStaticProtection(root);
    protectKeywordsInElement(root);
    ensureAudioButtons(root, lang);
    refreshAudioButtons(root, lang);
  }

  function paintButtons(root, lang){
    qsa(root, '.po-langbtn[data-po-lang]').forEach(function(btn){
      var isActive = normLang(btn.getAttribute('data-po-lang')) === normLang(lang);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      btn.classList.toggle('is-active', !!isActive);
    });
  }

  function renderAll(lang){
    var l = normLang(lang || getLang());
    qsa(document, ROOT_SEL).forEach(function(root){
      renderAxis(root, l);
      paintButtons(root, l);
      ensureStaticProtection(root);
    });
    initAudioEverywhere(l);
  }

  function bindLangButtons(){
    qsa(document, ROOT_SEL).forEach(function(root){
      if (root.__poTakimarahLangBound) return;
      root.__poTakimarahLangBound = true;
      var bar = qs(root, '[data-po-langbar]');
      if (!bar) return;
      bar.addEventListener('click', function(ev){
        var t = ev.target;
        if (!t) return;
        var btn = null;
        try{
          btn = t.closest ? t.closest('.po-langbtn[data-po-lang]') : null;
        }catch(e){ btn = null; }
        if (!btn && t.getAttribute && String(t.className || '').indexOf('po-langbtn') !== -1){
          btn = t;
        }
        if (!btn || !bar.contains(btn)) return;
        ev.preventDefault();
        ev.stopPropagation();
        var lang = normLang(btn.getAttribute('data-po-lang'));
        setLang(lang);
      }, false);
    });
  }

  function ensureStaticProtection(root){
    if (!root) return;
    qsa(root, '.notranslate').forEach(function(node){
      try{
        if (node.getAttribute('translate') !== 'no') node.setAttribute('translate', 'no');
      }catch(e){}
    });
  }

  function init(){
    bindLangButtons();
    renderAll(getLang());
  }

  function setLang(lang){
    var l = storeLang(lang);
    renderAll(l);
    notifyLocaleChanged();
    return l;
  }

  window.addEventListener('po:lexicon-ready', function(){
    __PO_PROTECT_CACHE__.key = '';
    __PO_PROTECT_CACHE__.re = null;
    try{ renderAll(getLang()); }catch(e){}
  });

  window.PoKatupirsia5TakimarahTextsFR_EN_ES_20260303 = {
    getLang: getLang,
    setLang: setLang,
    init: init,
    stopAudio: stopAudio
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
